import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";

import { BookingStatusType, ProfileType } from "../../../types/enum";

import { Grid, TextField } from "@material-ui/core";

import moment from "moment";

@inject("bookingRequestStore", "profileStore")
@withRouter
@observer
class BookingTicketingDetails extends Component {
    handleTicketUrlChange = e => {
        this.props.bookingRequestStore.setBooking("ticketUrl", e.target.value);
    };

    render() {
        const booking = this.props.bookingRequestStore.booking;
        const error = this.props.bookingRequestStore.error;
        if (!booking) return null;
        
        const { ticketUrl, status, createdById, dateStart } = booking;

        const { currentProfile } = this.props.profileStore;
        const isStaff = currentProfile && currentProfile?.type === ProfileType.Staff.ordinal;
        const { readOnly } = this.props;

        let confirmedEditable =
            status !== BookingStatusType.Cancelled.ordinal &&
            status !== BookingStatusType.Completed.ordinal &&
            moment(dateStart).endOf("day") >= moment() &&
            (!createdById || createdById === currentProfile?.id || isStaff);

        return (
            <Grid container spacing={8}>
                <Grid item xs={12} lg={6} className="gridBookingForm">
                    <TextField
                        label="Ticket URL"
                        value={ticketUrl || ""}
                        onChange={this.handleTicketUrlChange}
                        fullWidth
                        InputProps={{
                            readOnly: readOnly || !confirmedEditable
                        }}
                        placeholder="Example: https://www.eventbrite.com/"
                        error={error && error["ticketUrl"]}
                        helperText={error && error["ticketUrl"] ? error["ticketUrl"] : ""}
                    />
                </Grid>
            </Grid>
        );
    }
}

export default BookingTicketingDetails;
